export class RoleModel {
  name!: string;
}
